class TooltipFMEManager {
    constructor() {
        this.callback = null;
    }

    addCallback(callback) {
        this.callback = callback;
    }

    removeCallback() {
        this.callback = null;
    }

    invoke(payload) {
        if (this.callback) {
            this.callback(payload);
        }
    }
}

export default new TooltipFMEManager();
